import { type } from 'os';
import { MenuTypes as Type } from '../../../types/menu';

const initialState = {
  items: null,
  loading: false,
  error: null,
};

const CategoriesItemsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.GET_ITEM_LIST_REQUEST:
      return { ...state, loading: true, error: null, items: null };
    case Type.GET_ITEM_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
      };
    case Type.GET_ITEM_LIST_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false, items: null };
    case Type.RESET_ITEM_LIST_REQUEST:
      return { ...initialState };
    default:
      return state;
  }
};

export default CategoriesItemsReducer;
